import axios from "axios";

export const usersService = {
  getUsersService: (params) =>
    axios.get("/admins", { auth: true, params: { ...params } }),
  deleteUsersService: (id) => axios.delete(`/admins/${id}`, { auth: true }),
  addUsersService: (body) => axios.post("/admins", body, { auth: true }),
  editUsersService: (id, body) =>
    axios.patch(`/admins/${id}`, body, { auth: true }),
  changeStatusUserService: (id, body) =>
      axios.patch(`/admins/${id}/status`, body, {auth: true}),
};
